import React from "react";
import { Link } from "react-router-dom";

export const PendingNavbar = () => {
  return (
    <div className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box-two">
              <h4 className="page-title"></h4>
              <h1 className="welcome_text">PENDING REQUEST</h1>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <nav
              className="navbar navbar-light navbar-expand-md bg-faded justify-content-center"
              style={{
                boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.075)",
              }}
            >
              <a href="/" className="navbar-brand d-flex w-50 mr-auto"></a>
              <ul className="navbar-nav w-100 ml-auto justify-content-center">
                <li className="nav-item ml-auto">
                  <Link
                    className="nav-link"
                    to="/dashboard/pending"
                    style={{ borderRight: "3px solid #243050" }}
                  >
                    OFFICE REQUEST
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/dashboard/pending/leave"
                    style={{ borderRight: "3px solid #243050" }}
                  >
                    LEAVE REQUEST
                  </Link>
                </li>
              </ul>
              <div
                className="navbar-collapse collapse w-100"
                id="collapsingNavbar3"
              >
                <ul className="nav navbar-nav ml-auto w-100 justify-content-end">
                  <li className="nav-item ml-auto"></li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/pending/reusedcomponent/Navbar.js